<template>
  <div class="space-y-4">
    <div v-for="(field, index) in fields" :key="index">
      <label
        v-if="field.type !== 'checkbox'"
        :for="'field-' + index"
        class="mb-2 flex items-center gap-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        :class="{
          'text-red-500': validation[`fields[${index}].value`],
        }"
      >
        {{ field.name }}
        <div
          v-if="validation[`fields[${index}].value`]"
          v-hint="{
            position: 'bottom-center',
            yOffset: 8,
            text: $t(
              'form.validation.errors.' +
                validation[`fields[${index}].value`][0].error,
              validation[`fields[${index}].value`][0].params
            ),
            showDelay: 200,
          }"
        >
          <lucide-icon icon="CircleHelp" :size="14"></lucide-icon>
        </div>
      </label>

      <template v-if="field.type === 'text'">
        <input
          :id="'field-' + index"
          v-model="localFields[index].value"
          class="form-control h-10 w-full"
          :class="{
            'invalid text-red-500': validation[`fields[${index}].value`],
          }"
          type="text"
          @input="handleFieldInput(index)"
        />
      </template>

      <template v-if="field.type === 'textarea'">
        <textarea
          :id="'field-' + index"
          v-model="localFields[index].value"
          rows="2"
          :class="{
            'invalid text-red-500': validation[`fields[${index}].value`],
          }"
          class="form-control max-h-30 min-h-10 field-sizing-content w-full resize-none md:resize-y"
          @input="handleFieldInput(index)"
        ></textarea>
      </template>

      <template v-if="field.type === 'checkbox'">
        <Checkbox
          :value="localFields[index].value"
          size="md"
          :class="{
            invalid: validation[`fields[${index}].value`],
          }"
          @change="handleCheckboxChange($event, index)"
        >
          {{ field.name }}
          <div
            v-if="validation[`fields[${index}].value`]"
            v-hint="{
              position: 'bottom-center',
              yOffset: 8,
              text: $t(
                'form.validation.errors.' +
                  validation[`fields[${index}].value`][0].error,
                validation[`fields[${index}].value`][0].params
              ),
              showDelay: 200,
            }"
          >
            <lucide-icon icon="CircleHelp" :size="14"></lucide-icon>
          </div>
        </Checkbox>
      </template>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/ui/Checkbox';
import Hint from '@/libs/directives/Hint';

export default {
  name: 'DynamicFields',

  components: {
    Checkbox,
  },

  directives: {
    Hint,
  },

  props: {
    fields: {
      type: Array,
      required: true,
    },
    validation: {
      type: [Array, Object],
      default: () => [],
    },
  },

  data() {
    return {
      localFields: [],
    };
  },

  watch: {
    fields: {
      immediate: true,
      handler(newFields) {
        this.localFields = JSON.parse(JSON.stringify(newFields));
      },
    },
  },

  methods: {
    handleFieldInput(index) {
      this.$emit('clear-validation', `fields[${index}].value`);
      this.$emit('update:fields', this.localFields);
    },

    handleCheckboxChange(value, index) {
      this.localFields[index].value = value;
      this.$emit('clear-validation', `fields[${index}].value`);
      this.$emit('update:fields', this.localFields);
    },
  },
};
</script>
